import consumerApi from "api/services/consumer-api";
import { Photo, PhotoData } from "custom-types/Strain";
import formatImgixUrl from "utils/image/formatImgixUrl";
import logError from "utils/logError";

const getStrainPhotos = async (
  slug: string,
  page = 1,
  take = 36
): Promise<PhotoData> => {
  try {
    const result = await consumerApi.get(`api/strains/v1/${slug}/photos`, {
      params: {
        skip: (page - 1) * take,
        take: take,
      },
    });

    const {
      data: { data, metadata },
    } = result;

    if (!data) {
      return {
        data: [],
        metadata: { totalCount: 0 },
      };
    }

    data.length &&
      data.forEach((photo: Photo, i: number) => {
        if (photo.imageUrl) {
          data[i].imageUrl = formatImgixUrl(photo.imageUrl);
          data[i].sizes = [730, 730, 368, 320, 320, 730];
          data[i].alt = "user-provided strain";
        }
      });

    return { data, metadata };
  } catch (e) {
    logError(e.message, {
      functionName: "getStrainPhotos",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return {
      data: [],
      metadata: { totalCount: 0 },
    };
  }
};

export default getStrainPhotos;
